var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverdue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85 7.25V11.15L13.23 13.165L13.75 12.385L10.825 10.63V7.25H9.85ZM15.7 10.5V14.4H17V10.5H15.7ZM15.7 15.7V17H17V15.7H15.7ZM14.4 15.7C13.295 16.545 11.995 17 10.5 17C6.925 17 4 14.075 4 10.5C4 6.925 6.925 4 10.5 4C13.62 4 16.285 6.21 16.87 9.2H15.505C14.92 6.99 12.905 5.3 10.5 5.3C7.64 5.3 5.3 7.64 5.3 10.5C5.3 13.36 7.64 15.7 10.5 15.7C12.06 15.7 13.425 14.985 14.4 13.945V15.7Z",
    fill: "#702E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdue);
export default __webpack_public_path__ + "static/media/overdue.4b93175002d33bc51f77a021496a81e3.svg";
export { ForwardRef as ReactComponent };